/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const filterValidationErrorSchema = z.object({
  filterIndex: z.int(),
  message: z.string(),
  property: z.string(),
});
